const updateAlarm = function(alarmID, data, fn) {

  const init = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Basic '+btoa('myapiuser:123456'),
    },
    body: JSON.stringify(data),
  };

  fetch(`/api/alarms/${alarmID}`, init)
    .then(response => {
      return response.json();
    }).then(json => {
      fn(json);
    }).catch(function(err) {
      console.log('parsing failed', err);
    });
}

export {
  updateAlarm
};



// WEBPACK FOOTER //
// ./src/requests/updateAlarm.js